import React from 'react'
import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material'
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material'
import { useMetaEmbeddedSignup } from './hooks'
import type { MetaEmbeddedSignupButtonProps } from './types'

const MetaEmbeddedSignupButton: React.FC<MetaEmbeddedSignupButtonProps> = ({
  disabled = false,
  smbId,
  onCompleted,
  sx,
  buttonSx,
}) => {
  const {
    busy,
    buttonLabel,
    launchWhatsAppSignup,
  } = useMetaEmbeddedSignup({ disabled, smbId, onCompleted })

  return (
    <Box sx={[
      { display: 'flex', flexDirection: 'column', alignItems: { xs: 'stretch', sm: 'flex-end' }, gap: 1 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
      <Button
        variant="contained"
        color="primary"
        startIcon={busy ? <CircularProgress size={18} /> : <WhatsAppIcon />}
        onClick={launchWhatsAppSignup}
        disabled={disabled || busy}
        sx={[
          { minWidth: 140 },
          ...(Array.isArray(buttonSx) ? buttonSx : [buttonSx]),
        ]}
      >
        {buttonLabel}
      </Button>
    </Box>
  )
}

export default MetaEmbeddedSignupButton
